import I18N from '@leverege/i18n';
import { Blueprints } from '@leverege/api-attributes';
import SearchFieldEditor from "./editor/SearchFieldEditor.js";
import { SearchSettings, ClearSearch, MobileSearchSettings } from "./actions/index.js";
import { ScanSearchDesktop, ScanSearchMobile, SplitScanSearchHandler, ReplaceScanSearchHandler } from "./scan/index.js";
import { SearchListRenderer, SearchPopupRenderer } from "./renderer/index.js";
import { ApiSuggestionsPlugin } from "./suggestions/index.js";
import FilterPluginSetup from "./filter/PluginSetup.js";
import ResponsiveSearchBar from "./SearchBar.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.screens.group');
export default {
  install(molten) {
    FilterPluginSetup.install(molten);
    molten.addPlugin('ModelEditor', {
      type: 'filter.groupedText.field',
      editor: SearchFieldEditor
    });
    molten.addPlugin('Action', SearchSettings);
    molten.addPlugin('Action', MobileSearchSettings);
    molten.addPlugin('Action', ClearSearch);
    molten.addPlugin('Action', ScanSearchMobile);
    molten.addPlugin('Action', ScanSearchDesktop);
    molten.addPlugin('ScanTextHandler', SplitScanSearchHandler);
    molten.addPlugin('ScanTextHandler', ReplaceScanSearchHandler);
    molten.addPlugin('SearchSuggester', ApiSuggestionsPlugin);
    molten.addPlugin('SearchRenderer', SearchListRenderer);
    molten.addPlugin('SearchRenderer', SearchPopupRenderer);
    molten.addPlugin('DataViewer', {
      id: 'molten.dataViewer.search.SearchBar',
      type: 'molten.Search',
      name: tf('SearchBar.name'),
      icon: tfIcon('SearchBar.icon', 'fa fa-search fa-fw'),
      location: ['search'],
      matches: {
        type: 'GroupDataViewer',
        objectType: (cxt, cxtValue) => {
          const bps = Blueprints.getMapping();
          return Object.keys(bps).includes(cxtValue);
        }
      },
      component: ResponsiveSearchBar
    });
  }
};